import React from "react";
import logo from "../../assets/img/logo.svg";
import phone from "../../assets/img/ico/phone.svg";
import "../../assets/css/edit-profile.css";
import download from "../../assets/img/ico/download.svg";
import checkmark from "../../assets/img/ico/checkmark.svg";
import ToggleSwitch from "../ToggleSwitch";
import user from "../../assets/img/ico/user.svg";
import bookmark from "../../assets/img/ico/bookmark.svg";
import paperAndPen from "../../assets/img/ico/paper-and-pen.svg";
import home from "../../assets/img/ico/home.svg";
import scanner from "../../assets/img/ico/scanner.svg";
import plusSquare from "../../assets/img/ico/plus-square.svg";

export default function EditCompanyProfile() {

    // peut être remplacé par des true/false
    const [justificatifs, setJustificatifs] = React.useState({
        identity: "toto",
        diploma: null,
        cv: null,
        domicile: null,
        rib: null,
        vitale: null,
        medical: null,
        driving: null
    });

    const handleMissionToggle = (isOn) => {
        console.log('Possibilité de modifier les missions est :', isOn ? 'Activée' : 'Désactivée');
        // Ici, vous feriez probablement un appel API ou mettez à jour l'état global
    };

    const handleValidationToggle = (isOn) => {
        console.log('Validation automatique est :', isOn ? 'Activée' : 'Désactivée');
        // Logique pour le deuxième toggle
    };

    const handleNotificationsToggle = (isOn) => {
        console.log('Notifications sont :', isOn ? 'Activées' : 'Désactivées');
        // Logique pour le troisième toggle
    };

    return (
        <section className={"edit-profile-form company"}>
            <div>
                <h2>Mon profil</h2>
                <div>
                    <img src={logo} alt="user profile picture"></img>
                    <div className={"edit"}>
                        <img src={plusSquare} alt="edit profile picture icon"></img>
                    </div>
                    <h3>SAS Hotel fontaine</h3>
                </div>
            </div>
            <div>
                {/* Informations personnelles */}
                <h3>Informations personnelles</h3>
                <div>
                    <label>Nom de l'entreprise</label>
                    <input type="text" id="name" name="name" />
                </div>
                <div>
                    <label>Secteur d'activité</label>
                    <input type="text" id="address" name="address" />
                </div>
                <div>
                    <label>Numéro de téléphone principal</label>
                    <input type="tel" id="phone" name="phone" />
                </div>
                <div>
                    <label>Adresse complète du siège social</label>
                    <input type="text" id="address" name="address" />
                </div>
                <div>
                    <label>Email de contact principal</label>
                    <input type="email" id="email" name="email" />
                </div>
            </div>
            <div>
                {/* Responsables et contacts principaux */}
                <h3>
                    Responsables et contacts principaux
                </h3>
                <div>
                    <label>Nom du contact RH ou responsable intérim
                        <p className={"label-subtitle"}>(accès multi-comptes pour les recruteurs de l'agence)</p>
                    </label>
                    <input type="text" id="nameRH" name="nameRH"/>
                </div>
                <div>
                    <label>Email du contact</label>
                    <input type="email" id="emailRH" name="emailRH" />
                </div>
                <div>
                    <label>Numéro de téléphone direct</label>
                    <input type="tel" id="phoneRH" name="phoneRH" />
                </div>
                <div>
                    <label>Ajouter un autre contact</label>
                    <input type="text" id="otherRH" name="otherRH" />
                </div>
            </div>
            <div>
                {/* Moyens de paiement et facturations */}
                <h3>Moyens de paiement et facturations</h3>
                <div>
                    <label>IBAN / RIB de l'agence</label>
                    <input type="text" id="iban" name="iban" />
                </div>
                <div>
                    <label>BIC / SWIFT</label>
                    <input type="text" id="bic" name="bic" />
                </div>
                <div>
                    <label>Adresse de facturation</label>
                    <input type="text" id="addressFacturation" name="addressFacturation" />
                </div>
            </div>
            <div>
                {/* Préférences de gestion des missions */}
                <h3>Préférences de gestion des missions</h3>

                <ToggleSwitch initialValue={true} onToggle={handleMissionToggle} title={"Activer/Désactiver la possibilité de modifier directement les missions"} />
                <ToggleSwitch initialValue={true} onToggle={handleMissionToggle} title={"Délai de validation automatique des missions proposées"} />
                <ToggleSwitch initialValue={true} onToggle={handleMissionToggle} title={"Notifications pour nouvelles propositions d’intérimaires"} />
            </div>
                <div>
                    {/* Mes justificatifs */}
                    <h3>Mes justificatifs</h3>
                    <div className={"justificatifs"}>
                        <div><p>Justificatifs principaux</p></div>
                        <div>
                            <img src={user} />
                            <p>Kbis</p>
                            <img  src={justificatifs.identity ? checkmark : download} alt="user justificatif" />
                        </div><div>
                        <img src={bookmark} />
                        <p>Attestation URSAF</p>
                        <img  src={justificatifs.diploma ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={paperAndPen} />
                        <p>Contrats-cadres signés avec l’agence</p>
                        <img  src={justificatifs.cv ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={home} />
                        <p>Mandat SEPA</p>
                        <img  src={justificatifs.domicile ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={scanner} />
                        <p>Relevé d'Identité Bancaire</p>
                        <img  src={justificatifs.rib ? checkmark : download} alt="user justificatif" />
                    </div><div>
                        <img src={plusSquare} />
                        <p>Ajouter un document administratif</p>
                        <img  src={justificatifs.vitale ? checkmark : download} alt="user justificatif" />
                    </div>
                </div>
            </div>
            <div>
                <button className={"btn fill green"}>Enregistrer</button>
                <button className={"btn empty"}>Annuler</button>
            </div>
        </section>
    )
}